import { computed } from "vue";
import { OtpStoreModule } from "./modules/otpStore";
import store from ".";

/**
 * Состояние модуля OtpStoreModule
 * @returns 
 */
export const useOtpStore = () => {
  if (!store.hasModule('otpStore')) store.registerModule('otpStore', OtpStoreModule);

  

  return {
    isShowed: computed({
      get: () => store.state.otpStore.isShowed,
      set: (val) => store.commit('otpStore/SET_IS_SHOWED', val),
    }),
    /** время между отправкой подтверждения кода */
    attemptTime: computed({
      get: () => store.state.otpStore.attemptTime,
      set: (val) => store.commit('otpStore/SET_ATTEMPT_TIME', val)
    }),
    /** время жизни кода (сек) */
    currentTime: computed({
      get: () => store.state.otpStore.currentTime,
      set: (val) => store.commit('otpStore/SET_CURRENT_TIME', val)
    }),
    isSendSmsPending: computed({
      get: () => store.state.otpStore.isSendSmsPending,
      set: (val) => store.commit('otpStore/SET_IS_SEND_SMS_PENDING', val)
    }),
    isSendSmsCodePending: computed({
      get: () => store.state.otpStore.isSendSmsCodePending,
      set: (val) => store.commit('otpStore/SET_IS_SEND_SMS_CODE_PENDING', val)
    }),
    verifiedPhone: computed({
      get: () => store.state.otpStore.verifiedPhone,
      set: (val) => store.commit('otpStore/SET_VERIFIED_PHONE', val)
    }),
    isSendSmsAvailable: computed(() => store.getters['otpStore/isSendSmsAvailable']),
    isSendSmsCodeAvailable: computed(() => store.getters['otpStore/isSendSmsCodeAvailable']),
    startTimer: () => store.dispatch('otpStore/startTimer'),
    startAttemptTimer: () => store.dispatch('otpStore/startAttemptTimer'),
    open: () => store.dispatch('otpStore/open'),
    close: () => store.dispatch('otpStore/close'),
    /**
     * Check verification for phone
     * @param {string} phone 
     * @returns {boolean} true if verified
     */
    checkVerify: (phone) => store.dispatch('otpStore/checkVerify', phone),
  };
};
